import { Suspense, lazy } from 'react';
import AuthGuard from './components/AuthGuard';
import DashboardLayout from './components/dashboard/DashboardLayout';
import LoadingScreen from './components/LoadingScreen';
import MainLayout from './components/MainLayout';

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// 仪表盘
const Overview = Loadable(lazy(() => import('@pages/dashboard/Overview')));

// Error pages
const AuthorizationRequired = Loadable(lazy(() => import('@pages/AuthorizationRequired')));
const NotFound = Loadable(lazy(() => import('@pages/NotFound')));
const ServerError = Loadable(lazy(() => import('@pages/ServerError')));

// Other pages
const Home = Loadable(lazy(() => import('@pages/Home')));

// TODO: EJIAAN_APP_START

const Auth = Loadable(lazy(() => import('@pages/dashboard/AuthMenuList')));
const AuthEdit = Loadable(lazy(() => import('@pages/dashboard/AuthMenuList/AuthMenuEdit.js')));

// 角色管理
const RoleManage = Loadable(lazy(() => import('@pages/dashboard/RoleManage/index')));
const RoleEdit = Loadable(lazy(() => import('@pages/dashboard/RoleManage/RoleEdit')));
const RoleMenuEdit = Loadable(lazy(() => import('@pages/dashboard/RoleManage/RoleMenuEdit')));

// 用户管理
const UserManage = Loadable(lazy(() => import('@pages/dashboard/UserManage/index')));
const UserEdit = Loadable(lazy(() => import('@pages/dashboard/UserManage/RoleEdit')));

// 菜单管理
const MenuManage = Loadable(lazy(() => import('@pages/dashboard/MenuManage/index')));
const MenuEdit = Loadable(lazy(() => import('@pages/dashboard/MenuManage/MenuEdit')));

//训练营
const GameCamp = Loadable(lazy(() => import('@pages/dashboard/GameCamp/index')));
const GameCampEdit = Loadable(lazy(() => import('@pages/dashboard/GameCamp/GameCampEdit')));

//训练营资料表
const GameCampDoc = Loadable(lazy(() => import('@pages/dashboard/GameCampDoc/index')));
const GameCampDocEdit = Loadable(lazy(() => import('@pages/dashboard/GameCampDoc/CampDocEdit.js')));

//训练营配置表
const GameCampConfig = Loadable(lazy(() => import('@pages/dashboard/GameCampConfig/index.js')));
const GameCampConfigEdit = Loadable(lazy(() => import('@pages/dashboard/GameCampConfig/GameConfigEdit.js')));

//游戏列表
const GameList = Loadable(lazy(() => import('@pages/dashboard/Game/gameList')));
const AddGameList = Loadable(lazy(() => import('@pages/dashboard/Game/addGameList')));
//游戏分类
const GameClassificationList = Loadable(lazy(() => import('@pages/dashboard/Game/gameClassificationList')));
const AddGameClassificationList = Loadable(lazy(() => import('@pages/dashboard/Game/addGameClassificationList')));
//游戏星星参数设置
const StarsList = Loadable(lazy(() => import('@pages/dashboard/Game/starsList')));
const AddStarsList = Loadable(lazy(() => import('@pages/dashboard/Game/addStarsList')));

//游戏素材列表
const SourceList = Loadable(lazy(() => import('@pages/dashboard/Game/sourceList')));
const AddSourceList = Loadable(lazy(() => import('@pages/dashboard/Game/addSourceList')));

//游戏关卡列表
const LevelList = Loadable(lazy(() => import('@pages/dashboard/Game/levelList')));
const AddLevelList = Loadable(lazy(() => import('@pages/dashboard/Game/addLevelList')));

//游戏关卡规则
const LevelRules = Loadable(lazy(() => import('@pages/dashboard/Game/levelRules')));

//游戏反馈管理
const Feedback = Loadable(lazy(() => import('@pages/dashboard/Game/feedback')));

//游戏用户列表
const GameUserList = Loadable(lazy(() => import('@pages/dashboard/GameUserList/index.js')));

// 用户游戏解锁信息
const GameUserKeyList = Loadable(lazy(() => import('@pages/dashboard/GameUserKey/keyList.js')));
const GameUserKeyEdit = Loadable(lazy(() => import('@pages/dashboard/GameUserKey/GameUserKeyEdit.js')));

//用户游戏记录
const GameUsrList = Loadable(lazy(() => import('@pages/dashboard/GameUsrList/index.js')));

//用户训练主表
const GameCampCust = Loadable(lazy(() => import('@pages/dashboard/GameCampCust/index.js')));
const GameCampCustEdit = Loadable(lazy(() => import('@pages/dashboard/GameCampCust/GameCampCustEdit.js')));

//用户训练详细表
const GameCampCustMoreList = Loadable(lazy(() => import('@pages/dashboard/GameCampCustMore/index.js')));

//用户闯关历史记录
const GameUsrLevelHis = Loadable(lazy(() => import('@pages/dashboard/GameUsrLevelHis/index.js')));
//用户闯关记录
const GameUsrLevel = Loadable(lazy(() => import('@pages/dashboard/GameUsrLevel/index.js')));

//短信发送记录
const ShortMessage = Loadable(lazy(() => import('@pages/dashboard/Jurisdiction/shortMessage.js')));

//app版本信息
const Edition = Loadable(lazy(() => import('@pages/dashboard/Jurisdiction/edition.js')));
const EditionList = Loadable(lazy(() => import('@pages/dashboard/Jurisdiction/addEdition.js')));

//消息模版管理
const MessageTemplate = Loadable(lazy(() => import('@pages/dashboard/Jurisdiction/messageTemplate.js')));
const MessageTemplateEdit = Loadable(lazy(() => import('@pages/dashboard/Jurisdiction/messageTemplateEdit.js')));

//pk赛体验码列表
const ExperienceCode = Loadable(lazy(() => import('@pages/dashboard/Game/experienceCode')));

//游戏激活码列表
const GameCode = Loadable(lazy(() => import('@pages/dashboard/Game/gameCode')));

const routes = [
  {
    path: '*',
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '/',
        element: <Overview />
      }
    ]
  },
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '/auth',
        children: [
          {
            path: '/list',
            element: <Auth />
          },
          {
            path: '/edit',
            element: <AuthEdit />
          }
        ]
      },
      {
        path: '/members',
        children: [
          {
            path: '/list',
            element: <Auth />
          }
        ]
      },
      {
        path: '/game',
        children: [
          {
            path: '/gameList',
            element: <GameList />
          },
          {
            path: '/add',
            element: <AddGameList />
          },
          {
            path: '/edit/:id',
            element: <AddGameList />
          },
          {
            path: '/gameClassificationList',
            element: <GameClassificationList />
          },
          {
            path: '/gameClassificationList/add',
            element: <AddGameClassificationList />
          },
          {
            path: '/gameClassificationList/edit/:id',
            element: <AddGameClassificationList />
          },
          {
            path: '/starsList',
            element: <StarsList />
          },
          {
            path: '/starsList/add',
            element: <AddStarsList />
          },
          {
            path: '/starsList/edit/:id',
            element: <AddStarsList />
          },
          {
            path: '/sourceList',
            element: <SourceList />
          },
          {
            path: '/sourceList/add',
            element: <AddSourceList />
          },
          {
            path: '/sourceList/edit/:id',
            element: <AddSourceList />
          },
          {
            path: '/levelList',
            element: <LevelList />
          },
          {
            path: '/levelList/add',
            element: <AddLevelList />
          },
          {
            path: '/levelList/edit/:id',
            element: <AddLevelList />
          },
          {
            path: '/levelRules/add/',
            element: <LevelRules />
          },
          {
            path: '/levelRules/edit/:id',
            element: <LevelRules />
          },
          {
            path: '/feedback',
            element: <Feedback />
          }
          ,{
            path: '/gameCode',
            element: <GameCode />
          }
          ,{
            path: '/experienceCode',
            element: <ExperienceCode />
          }
        ]
      },
      {
        path: 'MenuManage',
        children: [
          {
            path: '/',
            element: <MenuManage />
          },
          {
            path: 'edit',
            element: <MenuEdit />
          }
        ]
      },
      {
        path: 'GameCamp',
        children: [
          {
            path: '/',
            element: <GameCamp />
          },
          {
            path: 'edit',
            element: <GameCampEdit />
          }
        ]
      },
      {
        path: 'GameCampDoc',
        children: [
          {
            path: '/',
            element: <GameCampDoc />
          },
          {
            path: 'edit',
            element: <GameCampDocEdit />
          }
        ]
      },
      {
        path: 'GameCampConfig',
        children: [
          {
            path: '/',
            element: <GameCampConfig />
          },
          {
            path: 'edit',
            element: <GameCampConfigEdit />
          }
        ]
      },
      {
        path: 'UserManage',
        children: [
          {
            path: '/',
            element: <UserManage />
          },
          {
            path: 'edit',
            element: <UserEdit />
          }
        ]
      },
      {
        path: 'RoleManage',
        children: [
          {
            path: '/',
            element: <RoleManage />
          },
          {
            path: '/edit/:id',
            element: <RoleEdit />
          },
          {
            path: 'MenuEdit',
            element: <RoleMenuEdit />
          }
        ]
      },
      {
        path: 'ShortMessage',
        children: [
          {
            path: '/',
            element: <ShortMessage />
          }
        ]
      },
      {
        path: 'MessageTemplate',
        children: [
          {
            path: '/',
            element: <MessageTemplate />
          },
          {
            path: '/add',
            element: <MessageTemplateEdit />
          },
          {
            path: '/edit/:id',
            element: <MessageTemplateEdit />
          }
        ]
      },
      {
        path: 'Edition',
        children: [
          {
            path: '/',
            element: <Edition />
          },
          {
            path: '/edit/:id',
            element: <EditionList />
          }
        ]
      },
      {
        path: 'userManage',
        children: [
          {
            path: 'GameUserList',
            children: [
              {
                path: '/',
                element: <GameUserList />
              }
            ]
          },
          {
            path: 'gameUsrKey',
            children: [
              {
                path: '/',
                element: <GameUserKeyList />
              },
              {
                path: 'edit',
                element: <GameUserKeyEdit />
              }
            ]
          },
          {
            path: 'gameUsrList',
            children: [
              {
                path: '/',
                element: <GameUsrList />
              }
            ]
          },
          {
            path: 'GameCampCustMoreList',
            children: [
              {
                path: '/',
                element: <GameCampCustMoreList />
              }
            ]
          },
          {
            path: 'GameCampCust',
            children: [
              {
                path: '/',
                element: <GameCampCust />
              },
              {
                path: '/edit',
                element: <GameCampCustEdit />
              }
            ]
          },
          {
            path: 'GameUsrLevelHis',
            children: [
              {
                path: '/',
                element: <GameUsrLevelHis />
              }
            ]
          },
          {
            path: 'GameUsrLevel',
            children: [
              {
                path: '/',
                element: <GameUsrLevel />
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '*',
    element: <MainLayout />,
    children: [
      {
        path: '/',
        element: <Home />
      },
      {
        path: '401',
        element: <AuthorizationRequired />
      },
      {
        path: '404',
        element: <NotFound />
      },
      {
        path: '500',
        element: <ServerError />
      },
      {
        path: '*',
        element: <NotFound />
      }
    ]
  }
];

export default routes;
